import React from "react";
import {Model, surveyLocalization} from "survey-core";
import {Survey} from "survey-react-ui";
import "survey-core/survey-core.css";
import {db} from "../../firebase";
import {addDoc, collection} from "firebase/firestore";

surveyLocalization.locales["el"] = {
    pagePrevText: "Πίσω",
    pageNextText: "Επόμενο",
    completeText: "Ολοκλήρωση",
    requiredError: "Απαιτείται απάντηση.",
    emailError: "Παρακαλώ εισάγετε μια έγκυρη διεύθυνση e-mail."
};

surveyLocalization.defaultLocale = "el";

const SurveyCenterForm = () => {
    const surveyJson = {
        completedHtml: "<h3>Σας ευχαριστούμε που συμπληρώσατε την έρευνα.</h3>",
        title: "Υποβολή Αιτήματος για προσθήκη Εξειδικευμένου Κέντρου Σπανίων Παθήσεων στον Ελληνικό Χάρτη Σπανίων Παθήσεων (Rare Diseases Greece Map)",
        description: "Συμπληρώστε τα παρακάτω στοιχεία για το κέντρο και τις σπάνιες παθήσεις που παρακολουθούνται",
        pages: [{
            name: "center", elements: [{
                type: "text",
                name: "Όνομα Κέντρου Σπανίων Παθήσεων",
                title: "Όνομα Κέντρου Σπανίων Παθήσεων:",
                isRequired: true
            }, {
                type: "text",
                name: "Νοσοκομείο στο οποίο ανήκει",
                title: "Νοσοκομείο στο οποίο ανήκει:",
                isRequired: true
            }, {
                type: "text", name: "Κλινική στην οποία ανήκει", title: "Κλινική στην οποία ανήκει:", isRequired: true
            }, {
                type: "text", name: "Διεύθυνση", title: "Διεύθυνση:", isRequired: true
            }, {
                type: "text",
                name: "Ονοματεπώνυμο Επιστημονικού Υπεύθυνου",
                title: "Ονοματεπώνυμο Επιστημονικού Υπεύθυνου:",
                isRequired: true
            }, {
                type: "text",
                name: "Τηλέφωνο Υπεύθυνου Επικοινωνίας",
                title: "Τηλέφωνο Υπεύθυνου Επικοινωνίας:",
                isRequired: true
            }, {
                type: "text", name: "Email", title: "Email:", inputType: "email", isRequired: true
            }, {
                type: "text", name: "Website", title: "Website:"
            }]
        }, {
            name: "diseases", elements: [{
                type: "matrixdynamic",
                name: "patises",
                title: "Παρακαλούμε σημειώστε όποια στοιχεία γνωρίζετε για τις Σπάνιες Παθήσεις των ασθενών:",
                description: "Είναι σημαντικό να συμπληρωθούν όσο το δυνατόν περισσότερα στοιχεία",
                addRowText: "Προσθήκη Πάθησης",
                removeRowText: "Αφαίρεση",
                rowCount: 1,
                columns: [{
                    name: "Ελληνικό Όνομα Πάθησης", title: "Ελληνικό Όνομα Πάθησης", cellType: "text"
                }, {
                    name: "Αγγλικό Όνομα Πάθησης", title: "Αγγλικό Όνομα Πάθησης", cellType: "text", isRequired: true
                }, {
                    name: "Συντομογραφία Πάθησης", title: "Συντομογραφία Πάθησης", cellType: "text"
                }, {
                    name: "ORPHACODE", title: "ORPHACODE", cellType: "text"
                }]
            }]
        }, {
            name: "applicant", elements: [{
                type: "text",
                name: "Ονοματεπώνυμο Ατόμου που πραγματοποιεί την αίτηση",
                title: "Ονοματεπώνυμο Ατόμου που πραγματοποιεί την αίτηση:",
                isRequired: true
            }, {
                type: "text",
                name: "Email Ατόμου που πραγματοποιεί την αίτηση",
                title: "Email Ατόμου που πραγματοποιεί την αίτηση:",
                isRequired: true,
                inputType: "email"
            }, {
                type: "html", name: "declaration", html: `<p>
              Η Ένωση Σπανίων Ασθενών Ελλάδος (Ε.Σ.Α.Ε) συλλέγει και επεξεργάζεται τα προσωπικά σας δεδομένα αποκλειστικά για σκοπούς επικοινωνίας. 
              Η επεξεργασία των δεδομένων σας διέπεται από τον Γενικό Κανονισμό για την Προστασία Δεδομένων (ΕΕ) 2016/679 και τον Νόμο 4624/2019. 
              Με την υποβολή αυτής της φόρμας, δηλώνετε ότι έχετε διαβάσει και κατανοήσει την παραπάνω ενημέρωση σχετικά με την επεξεργασία των προσωπικών σας δεδομένων.
            </p>`
            }]
        }]
    };

    const survey = new Model(surveyJson);

    // Append survey response to Firestore upon completion
    survey.onComplete.add(async (sender) => {

        const surveyData = sender.data;
        try {
            await addDoc(collection(db, "addCenterForm"), surveyData);
            console.log("Survey response saved to Firestore:", surveyData);
        } catch (error) {
            console.error("Error saving survey response to Firestore:", error);
        }
    });

    return (<div className="survey-container">
        <Survey model={survey}/>
        <footer
            style={{
                textAlign: "center", fontSize: "x-large", color: "#555"
            }}
        >
            Καπνικαρέας 19Α | Αθήνα | 10556 | T. 694 344 8509 | Ε. info@rarediseasesgreece.gr
        </footer>
    </div>);
};

export default SurveyCenterForm;
